/**
 * Shared formatting helpers.
 *
 * These live here rather than beside any one component because several
 * unrelated features render the same values - a player overlay, a text viewer,
 * an actions bar and the admin stats charts all print byte counts.
 */

/**
 * Format a byte count into a human-readable string.
 * e.g. 1048576 → "1.0 MB"
 */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} bytes`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}
